export default {
    setAlert(texto, tipo, funcao, textBotao){
      this.alert.texto      = texto ? texto : null
      this.alert.tipo       = tipo ? tipo : 'primary'
      this.alert.function   = funcao ? funcao : null
      this.alert.textBotao  = textBotao ? textBotao : 'Clique'
    },
    setLoading(texto, show){
      this.showLoading = show ? show : false
      this.textLoading = texto ? texto : null
    },
    isAutenticaded(){
      let params = this.getQueryParams()
      if(params.hasOwnProperty('logoff') && _.toString(params.logoff) == "1"){
        this.clearUsuario()
      }

      let token = localStorage.getItem('token')
      let refresh_token = localStorage.getItem('refresh_token')
      if(!_.isNull(this.$store.state.auth)){
        return true;
      }
      if(token && refresh_token){
        return true
      }
      return false;
    },
    getUsuario(callbackSuccess, callbackError){
      if(localStorage.getItem('token')){
        this.$root.setLoading("Buscando dados do usuário", true)
        this.$resources.Usuario.get('').then((response) => {
          this.$store.dispatch('changeUser', response.data.data)
          if(_.isFunction(callbackSuccess)){
            callbackSuccess()
          }
        }).catch((error) => {

          console.dir(error)
          this.clearUsuario()
          if(_.isFunction(callbackError)){
            callbackError()
          }
        })
      }
    },
    setUsuario(data, callback){
      localStorage.setItem('token',         data.access_token)
      localStorage.setItem('refresh_token', data.refresh_token)
      localStorage.setItem('expires',       data.expires)
      this.$store.dispatch('changeAuth',    data)
      this.$root.getUsuario(callback)
    },
    clearUsuario() {
      this.$store.dispatch('changeAuth', null)
      this.$store.dispatch('changeUser', null)
      localStorage.clear()
    },
    checkLocal(valueSet, successFunction, errorFunction){
      this.$root.setLoading("Analisando permissões de acesso", true)
      this.$resources.OAuth.post('/', {
        grant_type: "local",
      }).then((response) => {
        valueSet.serial = response.data.data.serial
        if(_.isFunction(successFunction)){
          successFunction()
        }
      }).catch((error) => {
        console.dir(error)
        //successFunction()

        /*if(_.isFunction(errorFunction)){
          errorFunction()
        }*/
      })
    },
    setErrorForm(errors) {
      this.errorsForm = _.isObject(errors) && _.size(errors) ? errors : {}
    },
    redirectToRV(urlRedirect, papel) {
      papel = papel ? papel : 0
      let token = localStorage.getItem('token')
      this.setLoading('Redirecionando... Aguarde...', true)
      $(() => {
        console.info(token)
        let div = $('#form-transparent')
        div.empty()

        let form = $("<form />")
        form.attr('method','post')
        form.attr('action',process.env.VUE_APP_ENDPOINT_URL + 'redevermelha/autenticacao/autenticar-externo')
        div.append(form)

        let input = $("<input />")
        input.attr('name', 'referer').attr('type', 'hidden')
        input.val(urlRedirect)
        form.append(input)

        input = $("<input />")
        input.attr('name', 'token').attr('type', 'hidden')
        input.val(token)
        form.append(input)

        input = $("<input />")
        input.attr('name', 'grupo_acesso').attr('type', 'hidden')
        input.val(papel)
        form.append(input)

        form.submit()
      })
    },
    getQueryParams() {
      let search = location.search
      let params = {}
      if(_.isString(search) && !_.isEmpty(search)){
          _.forEach(_.split(search.substr(1), '&'), (v, k) => {
              let item = _.split(v,'=')
              params[item[0]] = item[1]
          })
      }
      return params
    },
    refreshToken(callback) {
        if(this.isAutenticaded()){
            let serial = {
                grant_type: 'refresh_token',
                refresh_token: localStorage.getItem('refresh_token'),
                serial: null,
            }
            this.checkLocal(serial, () => {
                this.$root.setLoading("Autenticando usuário", true)
                this.$resources.OAuth.post('/', serial).then((response) => {
                    this.setUsuario(response.data.data, () => {
                        if(_.isFunction(callback)){
                            callback()
                        }
                        else {
                            this.loadApp = true
                        }
                    })
                }).catch((error) => {
                    this.loadApp = true
                    console.dir(error)
                    this.clearUsuario()
                    // this.clearCarrinho()
                    this.$router.push({name: 'autenticacao'})
                })
            })
        }
        else{
            this.clearUsuario()
            this.loadApp = true
        }
    },
    redirectAuthenticated(useNext, papel) {
        papel = papel ? papel : 0
        useNext = typeof useNext == undefined || !_.isBoolean(useNext) ? false : useNext
        if(this.$store.getters.isQuadro || this.$store.getters.isFiliadoMilitante){
            this.loadApp = true
            if(useNext){
                return true
            }
            this.$root.redirectToRV(process.env.VUE_APP_ENDPOINT_URL, papel)
        }
        else if(this.$store.getters.isPessoaFisica){
            this.$root.redirectToRV(process.env.VUE_APP_ENDPOINT_URL, papel)
        }
        else{
            this.$root.redirectToRV(process.env.VUE_APP_ENDPOINT_URL, papel)
        }
    },
    validateCPF (cpf) {
      cpf = cpf.replace(/\D/g, '');
      var numeros, digitos, soma, i, resultado, digitos_iguais;
      digitos_iguais = 1;
      if (cpf.length < 11)
        return false;
      for (i = 0; i < cpf.length - 1; i++)
        if (cpf.charAt(i) != cpf.charAt(i + 1))
        {
          digitos_iguais = 0;
          break;
        }
      if (!digitos_iguais) {
        numeros = cpf.substring(0,9);
        digitos = cpf.substring(9);
        soma = 0;
        for (i = 10; i > 1; i--)
          soma += numeros.charAt(10 - i) * i;
        resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
        if (resultado != digitos.charAt(0))
          return false;
        numeros = cpf.substring(0,10);
        soma = 0;
        for (i = 11; i > 1; i--)
          soma += numeros.charAt(11 - i) * i;
        resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
        if (resultado != digitos.charAt(1))
          return false;
        return true;
      }
      else
        return false;
    },
}



// WEBPACK FOOTER //
// ./src/methods.js